export const listDashboards = async params => {
  return await window.$vue.$get({
    endpoint: "/dashboards",
    params
  })
}

export const fetchDashboard = async uuid => {
  return await window.$vue.$get({
    endpoint: `/dashboards/${uuid}`
  })
}

export const createDashboard = async data => {
  return await window.$vue.$post({
    endpoint: "/dashboards",
    data
  })
}

export const updateDashboard = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/dashboards/${uuid}`,
    data
  })
}

export const changeDashboardStatus = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/dashboards/${uuid}/change-status`,
    data
  })
}
